module.exports = __webpack_public_path__ + "img/deletedForeverWhite.f7be3bf9.svg";